import {
  MRT_ColumnDef,
  MRT_ShowHideColumnsButton as MrtShowHideColumnsButton,
  MRT_ToggleDensePaddingButton as MrtToggleDensePaddingButton,
  MRT_ToggleFiltersButton as MrtToggleFiltersButton,
  MRT_ToggleFullScreenButton as MrtToggleFullScreenButton,
  MRT_ToggleGlobalFilterButton as MrtToggleGlobalFilterButton,
  MaterialReactTable,
} from "material-react-table";

import React, { useEffect, useMemo, useState } from "react";
import "./Users.scss";
import {
  ControlPointRounded,
  DeleteForever,
  ModeEdit,
  Refresh,
} from "@mui/icons-material";

import { Box, Button, Chip } from "@mui/material";

import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";

 // untuk indonesia

import storeMenu from "../../../stores";

import {
  BASE_URL,
  PPE_getApiSync,
  getValueFromLocalStorageFunc,
  handleLogOutGlobal_PPE,
  handleSwal,
  handleSwalResult,
  notify,
} from "../../../services/functions";

import Swal, { SweetAlertResult } from "sweetalert2";
import { ToastContainer } from "react-toastify";
import ModalCreateUsers from "../../modal/CreateUsers/Index";
import styles from "./Sites.module.scss";

// import LocalizationProvider from '@mui/lab/LocalizationProvider'
// import AdapterDateFns from '@mui/lab/AdapterDateFns';

// type Users = {
//   tanggal:string,
//   name: {
//     firstName: string,
//     lastName: string,
//   },
//   address: string,
//   city: string,
//   state: string,
// }

export type Users = {
  id: number;
  name: string;
  email: string;
  is_active: boolean;
  role: string;
};

const ListUser = () => {
  const [showModal, setShowModal] = useState(false);
  const [modalTitle, setModalTitle] = useState("Create"); // title modal (eg. Create user)
  const [modalStatus, setModalStatus] = useState(""); // status modal (eg. create / edit)
  const [modalRow, setModalRow] = useState({}); // data parsing for edit
  const [modalLoader, setModalLoader] = useState(true);

  const [showProgressBars, setShowProgressBars] = useState(true);
  const [showSkeleton, setShowSkeleton] = useState(true);

  const [rowList, setRowList] = useState<Users[]>([]);

  const [initialRender, setInitialRender] = useState(true);
  const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: 5 });

  useEffect(() => {
    // testing sementara tunggu ada data api baru di false
    setTimeout(() => {
      // list data table
      setShowProgressBars(false);
      setShowSkeleton(false);
    }, 1000);
  }, []);

  useEffect(() => {
    setTimeout(() => {
      // dispatch icon title
      storeMenu.dispatch({ type: "titleicon", text: "User" });

      // dispatch breadcrumb path with path links
      storeMenu.dispatch({
        type: "breadcrumbs",
        text: [
          { key: "Maintenance", value: "Maintenance" },
          { key: "Users", value: "Users" },
        ],
      });
    }, 100);

    //console.log(modalRow);
  }, [showModal, modalRow]);

  useEffect(() => {
    setTimeout(() => {
      getDataList();
    }, 150);
  }, []);

  useEffect(() => {
    if (!initialRender) {
      //console.log(JSON.stringify(pagination));
    } else {
      setInitialRender(false);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination]);

  let columns = useMemo<MRT_ColumnDef<Users>[]>(
    () => [
      {
        accessorKey: "id",
        header: "ID",
        filterFn: "contains",
        grow: true,
        visibleInShowHideMenu: false,
      },
      {
        accessorKey: "name",
        header: "Name",
        filterFn: "fuzzy",
        grow: true,
      },
      {
        accessorKey: "email",
        header: "Email",
        filterVariant: "text",
        // filterSelectOptions:['tes@gmail.com'],
        filterFn: "fuzzy",
        grow: true,
        Header: ({ column }) => {
          return <span>{column.columnDef.header}</span>;
        },
        muiTableHeadCellProps: {
          align: "left",
        },
      },
      {
        accessorKey: "is_active",
        header: "Active",
        filterVariant: "checkbox",
        filterFn: "contains",
        grow: true,
        Cell: ({ cell }) => {
          return cell.row.original.is_active ? (
            // <Chip color="success" label="Yes" size="small" sx={{width:'auto', boxShadow:'1px 1px 2px 1px grey'}}/>

            <Chip
              color="success"
              label="Yes"
              size="small"
              className="d-flex justify-content-center align-items-center "
              sx={{
                minWidth: "auto",
                color: "#56CA00",
                fontWeight: "500",
                height: "20px",
                backgroundColor: "rgba(86,202,0,0.16)",
                borderRadius: "16px",
                fontSize: "0.8125rem",
              }}
            />
          ) : (
            <Chip
              color="error"
              label="No"
              size="small"
              sx={{
                minWidth: "auto",
                color: "#FF4C51",
                fontWeight: "500",
                height: "20px",
                backgroundColor: "rgba(255, 76, 81,0.16)",
                borderRadius: "16px",
                fontSize: "0.8125rem",
              }}
            />

            // <Chip color="error" label="No" size="small" sx={{width:'auto', boxShadow:'1px 1px 2px 1px grey'}}/>
          );
          // <span>{cell.row.original.is_active ? 'Yes':'No'}</span>
        },
      },
      {
        accessorKey: "role",
        header: "Role",
        filterFn: "contains",
        grow: true,
        visibleInShowHideMenu: false,
      },
    ],
    [],
  );

  // let data: Users[] = [
  //   // data dummy
  //   {
  //     email: "tes@gmail.com",
  //     full_name: "tesname",
  //     is_active: true,
  //     is_superuser: false,
  //     token_user: "aaabbcctoken---",
  //     id: 0,
  //   },
  //   {
  //     email: "qa@gmail.com",
  //     full_name: "qaName",
  //     is_active: false,
  //     is_superuser: true,
  //     token_user: "aaabbccdddtoken---",
  //     id: 1,
  //   },
  //   {
  //     email: "tes@gmail.com",
  //     full_name: "tesname",
  //     is_active: true,
  //     is_superuser: false,
  //     token_user: "aaabbcctoken---",
  //     id: 0,
  //   },
  //   {
  //     email: "qa@gmail.com",
  //     full_name: "qaName",
  //     is_active: false,
  //     is_superuser: true,
  //     token_user: "aaabbccdddtoken---",
  //     id: 1,
  //   },
  //   {
  //     email: "tes@gmail.com",
  //     full_name: "tesname",
  //     is_active: true,
  //     is_superuser: false,
  //     token_user: "aaabbcctoken---",
  //     id: 0,
  //   },
  //   {
  //     email: "goooo@gmail.com",
  //     full_name: "qaName",
  //     is_active: false,
  //     is_superuser: true,
  //     token_user: "aaabbccdddtoken---",
  //     id: 1,
  //   },
  // ];

  // const getDataList = () => {
  //   setShowProgressBars(true);
  //   setShowSkeleton(true);

  //   const token = getValueFromLocalStorageFunc("IOT_TOKEN") ?? "";

  //   console.log("🔐 Token used for API request:", token);

  //   PPE_getApiSync(
  //     `${BASE_URL}/v1/users/list?limit=1000&offset=0`,
  //     null,
  //     "application/json",
  //     "GET",
  //     token
  //   ).then((response) => {
  //     setTimeout(() => {
  //       setShowProgressBars(false);
  //       setShowSkeleton(false);
  //     }, 77);

  //     if (Array.isArray(response)) {
  //       setRowList(response);
  //     } else {
  //       notify("error", "Failed to fetch users.", "TOP_CENTER");
  //     }
  //   });
  // };
  const getDataList = () => {
    setShowProgressBars(true);
    setShowSkeleton(true);

    const token = getValueFromLocalStorageFunc("IOT_TOKEN") ?? "";
    const apiUrl = `${BASE_URL}/v1/users/list?limit=1000&offset=0`;

    // console.log(
    //   "🔐 Token used for API request:",
    //   token ? "Token exists" : "No token",
    // );
    // console.log("🌐 API URL:", apiUrl);

    if (!token || token.length < 10) {
      console.error("❌ Invalid or missing token");
      notify(
        "error",
        "Invalid or missing authentication token. Please login again.",
        "TOP_CENTER",
      );
      setShowProgressBars(false);
      setShowSkeleton(false);
      window.location.href = "/login";
      return;
    }

    PPE_getApiSync(apiUrl, null, "application/json", "GET", token)
      .then((response) => {
        setTimeout(() => {
          setShowProgressBars(false);
          setShowSkeleton(false);
        }, 77);

        // console.log("📥 Raw API Response:", response);
        // console.log("📥 Response type:", typeof response);
        // console.log("📥 Is Array:", Array.isArray(response));

        if (response && response.statusCode) {
          console.error("API Error:", response);

          if (response.statusCode === "403") {
            notify(
              "error",
              "Access denied. You don't have permission to view users.",
              "TOP_CENTER",
            );
          } else if (response.statusCode === "401") {
            notify(
              "error",
              "Authentication failed. Please login again.",
              "TOP_CENTER",
            );
            setTimeout(() => {
              window.location.href = "/login";
            }, 2000);
          } else {
            notify(
              "error",
              response.msg || "Failed to fetch users.",
              "TOP_CENTER",
            );
          }

          setRowList([]);
          return;
        }

        if (Array.isArray(response)) {
          // console.log(
          //   "✅ Users data loaded successfully:",
          //   response.length,
          //   "users",
          // );
          setRowList(response);
        } else {
          console.warn("⚠️ Unexpected response format:", response);
          notify(
            "error",
            "Failed to fetch users. Unexpected response format.",
            "TOP_CENTER",
          );
          setRowList([]);
        }
      })
      .catch((error) => {
        console.error("❌ API call failed:", error);
        setShowProgressBars(false);
        setShowSkeleton(false);
        notify(
          "error",
          "Network error. Please check your connection.",
          "TOP_CENTER",
        );

        handleLogOutGlobal_PPE();
        window.location.href = "/login";

        setRowList([]);
      });
  };

  const toolbarButtonClick = (
    status: "Create" | "Edit" | "Delete",
    title: string,
    row?: any,
  ) => {
    if (status === "Delete") {
      handleSwal(
        "Delete",
        row.original?.["name"],
        (resultSwal: SweetAlertResult) => {
          if (resultSwal.isConfirmed) {
            handleSwalResult(
              "isConfirmed",
              row.original?.["name"],
              {
                endpoint: `${BASE_URL}/v1/users/delete`,
                obj: { id: row.original?.["id"] },
                body_type: "application/json",
                method: "DELETE",
                token: getValueFromLocalStorageFunc("IOT_TOKEN"),
              },
              () => {
                //getDataList();
                setTimeout(() => {
                  notify(
                    "info",
                    "Please refresh the page if data is not updated.",
                    "TOP_CENTER",
                  ); // Notify after some delay if data not updated
                }, 2000);
              },
            );
          } else if (resultSwal.dismiss === Swal.DismissReason.cancel) {
            handleSwalResult("cancelled");
          }
        },
      );
    } else {
      setModalStatus(status);
      setModalTitle(title);
      setShowModal(true);
      setModalLoader(true);

      if (status === "Edit") {
        setTimeout(() => {
          setModalLoader(false);
          setModalRow(row.original);
        }, 500);
      } else if (status === "Create") {
        setTimeout(() => {
          setModalLoader(false);
          setModalRow({
            email: "",
            name: "",
            is_active: true, // Default value, could be dynamic
            role: 2, // Default role, adjust as needed
          });
        }, 0);
      }
    }
  };

  // const handlePaginationChange = (newPage) => {
  //   console.log(newPage.pageSize);
  //   console.log(newPage.pageIndex);
  // };

  return (
    <>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <MaterialReactTable
          columns={columns}
          data={rowList}
          // enableColumnPinning
          // manualPagination={true}  // record tidak berubah jika page berubah
          paginationDisplayMode="pages" // pages->tampilkan per nomor halaman (1,2,3,...)
          muiPaginationProps={{
            size: "medium",
            color: "primary",
            shape: "rounded",
            variant: "outlined",
            // showRowsPerPage:true, // [5,10,15,All] show or not
            rowsPerPageOptions: [
              { value: 5, label: "5" },
              { value: 10, label: "10" },
              { value: 15, label: "15" },
              { value: rowList.length, label: "All" },
            ],
            // rowsPerPageOptions:[5,10,15],
            showFirstButton: true,
            showLastButton: true,
          }}
          onPaginationChange={setPagination} // harus set 'state -> pagination' juga
          // rowCount={100} //you can tell the pagination how many rows there are in your back-end data

          state={{
            pagination: pagination,
            showAlertBanner: false,
            showProgressBars: showProgressBars,
            showSkeletons: showSkeleton,
          }}
          // muiToolbarAlertBannerProps={{color:'error', children:'Network error'}}
          // positionToolbarAlertBanner='top'

          initialState={{
            columnPinning: { right: ["mrt-row-actions"] },
            density: "comfortable", // tinggi setiap row (spacious, comfortable, compact)
            columnOrder: [
              "mrt-row-numbers",
              "full_name",
              "email",
              "is_active",
              "is_superuser",
              "mrt-row-actions",
            ],
            columnVisibility: { id: false, token_user: false },
          }}
          renderTopToolbarCustomActions={({ table }) => {
            const modalEventOutChange = ({ tipe, value, form }) => {
              if (form === "create") {
                if (tipe === "close_modal") {
                  // setShowModal(value);
                  setTimeout(() => {
                    setShowModal(value);
                  }, 5);
                } else if (tipe === "close_after_success_save") {
                  setShowModal(value);
                  getDataList();
                }
              }
            };

            return (
              <Box>
                <div className="d-flex gap-2 mb-2 mt-2 ms-2">
                  {
                    <Button
                      onClick={() => {
                        toolbarButtonClick("Create", "Create Site");
                      }}
                      variant="contained"
                      className="d-flex justify-content-between"
                      style={{
                        backgroundColor: "#008ea1",
                        paddingLeft: "5px",
                        paddingRight: "10px",
                      }}
                    >
                      <ControlPointRounded titleAccess="Create" />
                      <span className="ms-1" title="Create">
                        Create User
                      </span>
                    </Button>
                  }

                  <Button
                    color="secondary"
                    onClick={() => {
                      getDataList();
                    }}
                    variant="outlined"
                    className="d-flex justify-content-center align-items-center"
                    style={{
                      paddingLeft: "5px",
                      paddingRight: "5px",
                      minWidth: "0",
                    }}
                  >
                    <Refresh titleAccess="Refresh" />
                    {/* <span className='ms-1'>Refresh</span>  */}
                  </Button>
                </div>

                <ModalCreateUsers
                  par_show={showModal ?? false}
                  title={modalTitle}
                  status={modalStatus}
                  par_statusLoader={modalLoader}
                  row={modalRow}
                  outChange={modalEventOutChange}
                />
              </Box>
            );
          }}
          enableFacetedValues // untuk filterVariant = 'multi-select' hanya terambil data unik otomatis
          renderToolbarInternalActions={({ table }) => {
            return (
              <Box>
                {/* <IconButton onClick={()=>window.print()}>
                              <Print />
                            </IconButton> */}
                <MrtToggleGlobalFilterButton table={table} />
                <MrtToggleFiltersButton table={table} />
                <MrtShowHideColumnsButton table={table} />
                <MrtToggleDensePaddingButton table={table} />
                <MrtToggleFullScreenButton table={table} />
              </Box>
            );
          }}
          // custom if rows empty / kosong
          renderEmptyRowsFallback={({ table }) => {
            return (
              <p
                style={{
                  margin: 0,
                  fontFamily: '"Roboto", "Helvetica", "Arial",sans-serif',
                  fontStyle: "italic",
                  letterSpacing: "0.00938em",
                  width: "100%",
                  color: "rgba(0, 0, 0, 0.6)",
                  lineHeight: "1.5",
                  textAlign: "center",
                  paddingTop: "2rem",
                  paddingBottom: "2rem",
                  fontWeight: 400,
                }}
              >
                No records to display
              </p>
            );
          }}
          muiTableBodyProps={{
            // styling body data
            sx: {
              "& tr:nth-of-type(odd) > td": {
                backgroundColor: "aliceblue",
              },
            },
          }}
          muiTableBodyCellProps={{
            // styling semua cell dalam body data
            sx: {
              // borderRight:'1px solid #e0e0e0'
            },
          }}
          // enableRowSelection

          enableTopToolbar={true}
          muiTopToolbarProps={{
            // styling top Toolbar
            sx: {
              // background:'linear-gradient(45deg, darkcyan, white)'
              boxShadow: "0px 1px 12px -7px grey inset", // shadow inset toolbar di atas
              paddingTop: "7px",
              // borderBottom:'1px solid lightgrey'
            },
          }}
          muiTableHeadCellProps={{
            // styling head cell / nama column
            sx: {
              backgroundColor: "transparent",
              textAlign: "left",
              paddingTop: "10px",
              paddingBottom: "10px",
              display: "flex",
              justifyContent: "center",
            },
          }}
          columnFilterDisplayMode="subheader"
          enableColumnFilterModes // fuzzy, contains, so on...
          enableColumnOrdering
          enableColumnResizing
          enableRowNumbers
          rowNumberDisplayMode="static" // row number follow sort or not (static = fix 1,2,3,..; original = flexible when sort 2,1,3,...)
          enableRowActions={true} // Temporarily enable for testing
          positionActionsColumn="first"
          displayColumnDefOptions={{
            "mrt-row-numbers": {
              // Cell: ({staticRowIndex}) => {  // menyebabkan nomor ter-reset jadi 1 setiap page berubah
              //     return <span>{(staticRowIndex??0) + 1}</span>
              // },

              visibleInShowHideMenu: true, // show this column in "show/hide columns"
              enableHiding: true, // can hide or not menu "show/hide columns"
              // ,Cell:({cell, staticRowIndex})=>{
              //     console.log(cell)
              //     return (
              //       <span>{(staticRowIndex??0) + 1}</span>
              //     )
              // }
              Header: "No",
            },
            "mrt-row-actions": {
              header: "Actions",
              size: 100,
            },
          }}
          renderRowActions={({ cell, row, table }) => {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            let cellContent = row.original?.["name"]?.["firstName"];
            // console.log("cellContent")
            // console.log("ID : ", cell.row.id)
            // console.log("Index : ", cell.row.index)
            // console.log("Address : ", row.original?.['address'])
            return (
              <div className="d-flex align-items-center gap-2">
                <div
                  className={`${styles["ppe-icon-actions"]} ${styles["edit"]}`}
                  title="Edit"
                  onClick={() => {
                    toolbarButtonClick("Edit", "Edit Site", row);
                  }}
                >
                  <ModeEdit sx={{ fill: "mediumslateblue !important" }} />
                </div>

                <div
                  className={`${styles["ppe-icon-actions"]} ${styles["delete"]}`}
                  title="Hapus"
                  onClick={() => {
                    toolbarButtonClick("Delete", "Delete Site", row);
                  }}
                >
                  <DeleteForever sx={{ fill: "red !important" }} />
                </div>
              </div>
            );
          }}
        />
      </LocalizationProvider>

      <ToastContainer draggable pauseOnHover />
      {/* <LocalizationProvider dateAdapter={AdapterDate}  */}
    </>
  );
};

export default ListUser;
